export const formatDate = (date) => date.toISOString().split("T")[0];
export const today = formatDate(new Date());